export const tempData = {
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone": "",
    "skills": [],
    "work_preference": "",
    "had_covid": false,
    "had_covid_at": "",
    "vaccinated": false,
    "vaccinated_at": "",
    "will_organize_devtalk": false,
    "devtalk_topic": "",
    "something_special": ""
}